import React, { useState, useEffect } from 'react';
import {
  ArrowLeftOutlined,
  PlusOutlined,
  DeleteOutlined,
} from '@ant-design/icons';
import { Card, List, Button, Input, Form, Switch, Row, Col } from 'antd';
import PropTypes from 'prop-types';
import LinkButton from '../../../../components/link-button';
import { addseries, putseries ,idseries } from '../../../../api/index';

const { Item } = List;

const UserDetail = ({ history, location }) => {
  const initialData = {
    id: '',
    name: {},
    url: {},
    desc: {},
    entries: [],
    test_functions: [],
    owner: '',
    director: '',
    rd_manager: '',
    validation_test_manager: '',
    pilot_test_manager: '',
    category_id: '',
    group_id: '',
    bizline_id: '',
    state: '',
    validation_test_group: '',
    spec_prefix: '',
    virtual: false,
    special: false,
    forChina: false,
    forGlobal: false,
    autoTest: false,
  };

  const [data, setData] = useState(initialData);
  const [isEditing, setIsEditing] = useState(false);
  const isNew = !location.state;
  const [form] = Form.useForm();
  const [nameKeys, setNameKeys] = useState(Object.keys(initialData.name));
  const [urlKeys, setUrlKeys] = useState(Object.keys(initialData.url));
  const [descKeys, setDescKeys] = useState(Object.keys(initialData.desc));

  useEffect(() => {
    if (!isNew) {
      const fetchData = async () => {
        try {
          const result1 = await idseries(location.state);
          // const result = location.state;
          const result=result1.result
          console.log('result:', result);
          setData(result);
          form.setFieldsValue(result);
          setNameKeys(Object.keys(result.name));
          setUrlKeys(Object.keys(result.url));
          setDescKeys(Object.keys(result.desc));
        } catch (error) {
          console.error('Error fetching user details:', error);
        }
      };
      fetchData();
    }
  }, [isNew, location.state, form]);

  const handleEdit = () => {
    setIsEditing(true);
  };

  const handleSave = () => {
    form.validateFields().then(values => {
      const processFieldKeys = (keys, type) => {
        return keys.reduce((acc, key) => {
          const fieldKey = values[`key_${type}_${key}`];
          const fieldValue = values[`${type}_${key}`];
          if (fieldKey) {
            acc[fieldKey] = fieldValue;
          }
          return acc;
        }, {});
      };

      const updatedName = processFieldKeys(nameKeys, 'name');
      const updatedUrl = processFieldKeys(urlKeys, 'url');
      const updatedDesc = processFieldKeys(descKeys, 'desc');

      const { entries, test_functions, ...restValues } = values;
      const cleanedValues = Object.keys(restValues).reduce((acc, key) => {
        if (
          !key.startsWith('key_') &&
          !key.startsWith('name_') &&
          !key.startsWith('url_') &&
          !key.startsWith('desc_')
        ) {
          acc[key] = restValues[key];
        }
        return acc;
      }, {});

      const updatedData = {
        ...data,
        ...cleanedValues,
        name: updatedName,
        url: updatedUrl,
        desc: updatedDesc,
        entries: Array.isArray(entries)
          ? entries
          : entries
          ? entries.split(',').map(entry => entry.trim())
          : [],
        test_functions: Array.isArray(test_functions)
          ? test_functions
          : test_functions
          ? test_functions.split(',').map(func => func.trim())
          : [],
      };

      if (isNew) {
        addseries(updatedData)
          .then(response => {
            if (response.status === 200) {
              history.goBack();
            }
          })
          .catch(error => {
            console.error('Error adding new user data:', error);
          });
      } else {
        console.log(updatedData, 'updatedData');
        putseries (updatedData)
          .then(response => {
            if (response.status === 200) {
              setData(updatedData);

              setIsEditing(false);
            }
          })
          .catch(error => {
            console.error('Error updating user data:', error);
          });
      }
    });
  };

  const addField = fieldType => {
    const newKey = `newLang${Math.random().toString(36).substr(2, 5)}`;
    if (fieldType === 'name') {
      setNameKeys([...nameKeys, newKey]);
    } else if (fieldType === 'url') {
      setUrlKeys([...urlKeys, newKey]);
    } else if (fieldType === 'desc') {
      setDescKeys([...descKeys, newKey]);
    }
    form.setFieldsValue({
      ...form.getFieldsValue(),
      [`key_${fieldType}_${newKey}`]: '',
      [`${fieldType}_${newKey}`]: '',
    });
  };

  const removeField = (key, fieldType) => {
    const setStateFunc =
      fieldType === 'name'
        ? setNameKeys
        : fieldType === 'url'
        ? setUrlKeys
        : setDescKeys;
    setStateFunc(keys => keys.filter(k => k !== key));

    const fields = form.getFieldsValue();
    delete fields[`key_${fieldType}_${key}`];
    delete fields[`${fieldType}_${key}`];
    form.setFieldsValue(fields);
  };

  const renderTitle = (
    <span>
      <LinkButton onClick={() => history.goBack()}>
        <ArrowLeftOutlined style={{ marginRight: 10, fontSize: 20 }} />
      </LinkButton>
      <span>{isNew ? '新增系列' : '系列详情'}</span>
    </span>
  );

  const renderField = (keys, fieldType) => (
    <>
      {keys.map(key => (
        <Item
          key={key}
          style={{ marginBottom: 16 }}
        >
          <Row gutter={16}>
            <Col span={6}>
              <span className='left'>{`${
                fieldType === 'name'
                  ? '名称'
                  : fieldType === 'url'
                  ? 'URL'
                  : '描述'
              }：`}</span>
            </Col>
            <Col span={14}>
              {isEditing ? (
                <>
                  <Form.Item
                    name={`key_${fieldType}_${key}`}
                    initialValue={key}
                    noStyle
                  >
                    <Input
                      style={{ width: '30%', marginRight: 8 }}
                      placeholder='键'
                    />
                  </Form.Item>
                  <Form.Item
                    name={`${fieldType}_${key}`}
                    initialValue={data[fieldType][key]}
                    noStyle
                  >
                    <Input.TextArea
                      style={{ width: '60%', marginRight: 8 }}
                      placeholder='值'
                      rows={2}
                    />
                  </Form.Item>
                </>
              ) : (
                <span>{`${key}: ${data[fieldType][key]}`}</span>
              )}
            </Col>
            <Col span={4}>
              {isEditing && (
                <Button
                  type='danger'
                  icon={<DeleteOutlined />}
                  onClick={() => removeField(key, fieldType)}
                />
              )}
            </Col>
          </Row>
        </Item>
      ))}
      {isEditing && (
        <Item>
          <Button
            type='dashed'
            onClick={() => addField(fieldType)}
            icon={<PlusOutlined />}
          >
            添加
            {fieldType === 'name'
              ? '名称'
              : fieldType === 'url'
              ? 'URL'
              : '描述'}
          </Button>
        </Item>
      )}
    </>
  );

  const renderSwitch = (label, field) => (
    <Item style={{ marginBottom: 16 }}>
      <Row gutter={16}>
        <Col span={6}>
          <span className='left'>{label}</span>
        </Col>
        <Col span={14}>
          <Form.Item
            name={field}
            valuePropName='checked'
            initialValue={data[field]}
            noStyle
          >
            <Switch disabled={!isEditing} />
          </Form.Item>
        </Col>
      </Row>
    </Item>
  );

  return (
    <Card title={renderTitle}>
      <List className='user-detail'>
        <Form
          form={form}
          layout='vertical'
        >
          <Item style={{ marginBottom: 16 }}>
            <Row gutter={16}>
              <Col span={6}>
                <span className='left'>ID：</span>
              </Col>
              <Col span={14}>
                <Form.Item
                  name='id'
                  noStyle
                >
                  <Input readOnly={!isEditing} />
                </Form.Item>
              </Col>
            </Row>
          </Item>
          {renderField(nameKeys, 'name')}

          <Item style={{ marginBottom: 16 }}>
            <Row gutter={16}>
              <Col span={6}>
                <span className='left'>文档条目（英文逗号为分隔）：</span>
              </Col>
              <Col span={14}>
                <Form.Item
                  name='entries'
                  initialValue={data.entries ? data.entries.join(', ') : ''}
                  noStyle
                >
                  <Input readOnly={!isEditing} />
                </Form.Item>
              </Col>
            </Row>
          </Item>
          {renderField(urlKeys, 'url')}

          <Item style={{ marginBottom: 16 }}>
            <Row gutter={16}>
              <Col span={6}>
                <span className='left'>测试功能（英文逗号为分隔）：</span>
              </Col>
              <Col span={14}>
                <Form.Item
                  name='test_functions'
                  initialValue={
                    data.test_functions ? data.test_functions.join(', ') : ''
                  }
                  noStyle
                >
                  <Input readOnly={!isEditing} />
                </Form.Item>
              </Col>
            </Row>
          </Item>

          {renderField(descKeys, 'desc')}
          <Item style={{ marginBottom: 16 }}>
            <Row gutter={16}>
              <Col span={6}>
                <span className='left'>负责人：</span>
              </Col>
              <Col span={14}>
                <Form.Item
                  name='owner'
                  initialValue={data.owner}
                  noStyle
                >
                  <Input readOnly={!isEditing} />
                </Form.Item>
              </Col>
            </Row>
          </Item>
          <Item style={{ marginBottom: 16 }}>
            <Row gutter={16}>
              <Col span={6}>
                <span className='left'>主管：</span>
              </Col>
              <Col span={14}>
                <Form.Item
                  name='director'
                  initialValue={data.director}
                  noStyle
                >
                  <Input readOnly={!isEditing} />
                </Form.Item>
              </Col>
            </Row>
          </Item>
          <Item style={{ marginBottom: 16 }}>
            <Row gutter={16}>
              <Col span={6}>
                <span className='left'>研发经理：</span>
              </Col>
              <Col span={14}>
                <Form.Item
                  name='rd_manager'
                  initialValue={data.rd_manager}
                  noStyle
                >
                  <Input readOnly={!isEditing} />
                </Form.Item>
              </Col>
            </Row>
          </Item>
          <Item style={{ marginBottom: 16 }}>
            <Row gutter={16}>
              <Col span={6}>
                <span className='left'>验证测试经理：</span>
              </Col>
              <Col span={14}>
                <Form.Item
                  name='validation_test_manager'
                  initialValue={data.validation_test_manager}
                  noStyle
                >
                  <Input readOnly={!isEditing} />
                </Form.Item>
              </Col>
            </Row>
          </Item>
          <Item style={{ marginBottom: 16 }}>
            <Row gutter={16}>
              <Col span={6}>
                <span className='left'>中试经理：</span>
              </Col>
              <Col span={14}>
                <Form.Item
                  name='pilot_test_manager'
                  initialValue={data.pilot_test_manager}
                  noStyle
                >
                  <Input readOnly={!isEditing} />
                </Form.Item>
              </Col>
            </Row>
          </Item>
          <Item style={{ marginBottom: 16 }}>
            <Row gutter={16}>
              <Col span={6}>
                <span className='left'>类别 ID：</span>
              </Col>
              <Col span={14}>
                <Form.Item
                  name='category_id'
                  initialValue={data.category_id}
                  noStyle
                >
                  <Input readOnly={!isEditing} />
                </Form.Item>
              </Col>
            </Row>
          </Item>
          <Item style={{ marginBottom: 16 }}>
            <Row gutter={16}>
              <Col span={6}>
                <span className='left'>组 ID：</span>
              </Col>
              <Col span={14}>
                <Form.Item
                  name='group_id'
                  initialValue={data.group_id}
                  noStyle
                >
                  <Input readOnly={!isEditing} />
                </Form.Item>
              </Col>
            </Row>
          </Item>
          <Item style={{ marginBottom: 16 }}>
            <Row gutter={16}>
              <Col span={6}>
                <span className='left'>业务线 ID：</span>
              </Col>
              <Col span={14}>
                <Form.Item
                  name='bizline_id'
                  initialValue={data.bizline_id}
                  noStyle
                >
                  <Input readOnly={!isEditing} />
                </Form.Item>
              </Col>
            </Row>
          </Item>
          <Item style={{ marginBottom: 16 }}>
            <Row gutter={16}>
              <Col span={6}>
                <span className='left'>状态：</span>
              </Col>
              <Col span={14}>
                <Form.Item
                  name='state'
                  initialValue={data.state}
                  noStyle
                >
                  <Input readOnly={!isEditing} />
                </Form.Item>
              </Col>
            </Row>
          </Item>
          <Item style={{ marginBottom: 16 }}>
            <Row gutter={16}>
              <Col span={6}>
                <span className='left'>验证测试组：</span>
              </Col>
              <Col span={14}>
                <Form.Item
                  name='validation_test_group'
                  initialValue={data.validation_test_group}
                  noStyle
                >
                  <Input readOnly={!isEditing} />
                </Form.Item>
              </Col>
            </Row>
          </Item>
          <Item style={{ marginBottom: 16 }}>
            <Row gutter={16}>
              <Col span={6}>
                <span className='left'>规格前缀：</span>
              </Col>
              <Col span={14}>
                <Form.Item
                  name='spec_prefix'
                  initialValue={data.spec_prefix}
                  noStyle
                >
                  <Input readOnly={!isEditing} />
                </Form.Item>
              </Col>
            </Row>
          </Item>
          {renderSwitch('虚拟', 'virtual')}
          {renderSwitch('特别', 'special')}
          {renderSwitch('适用于中国', 'forChina')}
          {renderSwitch('适用于全球', 'forGlobal')}
          {renderSwitch('自动测试', 'autoTest')}
          <Item style={{ marginTop: 16 }}>
            <Row gutter={16}>
              <Col span={6}></Col>
              <Col span={14}>
                {isEditing ? (
                  <>
                    <Button
                      type='primary'
                      onClick={handleSave}
                    >
                      保存
                    </Button>
                    <Button
                      style={{ marginLeft: 8 }}
                      onClick={() => setIsEditing(false)}
                    >
                      取消
                    </Button>
                  </>
                ) : (
                  <Button
                    type='primary'
                    onClick={handleEdit}
                  >
                    编辑
                  </Button>
                )}
              </Col>
            </Row>
          </Item>
        </Form>
      </List>
    </Card>
  );
};

UserDetail.propTypes = {
  history: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
};

export default UserDetail;
